import React from 'react';
import { motion } from 'framer-motion';
import { ChefHat, Sun, Users, ArrowUpRight } from 'lucide-react';
const EDP_URL = 'https://viewer.joomag.com/india-basin-equitable-development-plan-edp/0587225001643671116?short';
export function About() {
  const facilities = [{
    icon: <ChefHat size={32} data-id="element-16" data-mp="2yrwyw47tx4cu" />,
    title: 'Commercial Kitchen',
    detail: 'A fully equipped, modern 520 sq ft commercial kitchen — industrial ovens, high-performance stove tops, and a full refrigeration system.',
    color: 'bg-foodTomato'
  }, {
    icon: <Sun size={32} data-id="element-17" data-mp="38o8bkvbbzw7t" />,
    title: 'Shaded Patio',
    detail: 'A 216 sq ft covered patio open to the public, with comfortable seating for up to 8 guests.',
    color: 'bg-foodGold'
  }, {
    icon: <Users size={32} data-id="element-18" data-mp="3mhrayjkbqow1" />,
    title: 'Open-Air Patio',
    detail: 'A 321 sq ft open-air patio open to the public, with seating for up to 16 guests.',
    color: 'bg-foodOrange'
  }];
  return <section id="about" className="py-20 lg:py-32 bg-foodCard border-y-4 border-foodMaroon" data-id="element-19" data-mp="2lqz6egttp4st">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-20" data-mp="2grmf9jvx5bkf">
        {/* Intro */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-3xl mb-16" data-id="element-21" data-mp="2cq98n7l054cg">
          <div className="inline-block bg-foodGold text-foodMaroon font-bold px-4 py-1 border-2 border-foodMaroon mb-6 rotate-[-2deg]" data-id="element-22" data-mp="30g3lvq98gux8">
            About The Food Pavilion
          </div>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold uppercase mb-6 leading-[1.1]" data-id="element-23" data-mp="2vn24nblk0jah">
            A Hub for Culinary &{' '}
            <span className="text-foodTomato" data-id="element-24" data-mp="3o5xx63dwmbfd">Community</span> Experiences
          </h2>
          <p className="text-xl font-medium text-foodMaroon/80" data-id="element-25" data-mp="3jefvfd4246tc">
            The Food Pavilion is a state-of-the-art facility — a dynamic space
            for chefs, food entrepreneurs, and community members to come
            together and create.
          </p>
        </motion.div>

        {/* Facility Overview */}
        <div className="grid md:grid-cols-3 gap-8 mb-20" data-id="element-26" data-mp="3thv1e5c9b7h0">
          {facilities.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-foodCream border-4 border-foodMaroon p-8" data-id="element-27" data-mp="1e29qejg8mu0" data-mpi={idx}>
              <div className={`${item.color} text-foodMaroon inline-flex p-3 border-2 border-foodMaroon shadow-[2px_2px_0px_0px_#2A1B14] mb-6`} data-id="element-28" data-mp="18s5mxtfgtnou">
                {item.icon}
              </div>
              <h3 className="text-2xl font-extrabold uppercase mb-3" data-id="element-29" data-mp="2xdcrfkhvxny6">
                {item.title}
              </h3>
              <p className="font-medium text-lg" data-id="element-30" data-mp="2tcart2k239vo">{item.detail}</p>
            </motion.div>)}
        </div>

        {/* Our Purpose */}
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-31" data-mp="32bo21xg082hg">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-32" data-mp="329be93nkexwh">
            <h3 className="text-3xl md:text-4xl font-extrabold uppercase mb-6" data-id="element-33" data-mp="3q0grdb24fc33">
              Our <span className="text-foodOrange" data-id="element-34" data-mp="3l374a227fcif">Purpose</span>
            </h3>
            <p className="text-lg font-medium mb-4" data-id="element-35" data-mp="1vmfuuwu1n166">
              The Food Pavilion is a partnership made possible through the India
              Basin Waterfront Park Equitable Development Plan (EDP) — a
              landmark plan, a first for San Francisco, that provides a
              blueprint for a park designed by and for the community while
              improving economic opportunity and environmental health for
              residents.
            </p>
            <p className="text-lg font-medium mb-4" data-id="element-36" data-mp="221ej7dqee7tc">
              The plan outlines strategies to build and sustain local job
              creation, with emphasis on the Black community; to support
              Bayview-Hunters Point commercial corridors beyond the park; and to
              use the physical spaces and park programming to build community
              cohesion and social capital.
            </p>
            <p className="text-base font-medium text-foodMaroon/70" data-id="element-37" data-mp="1o36lh3ljf2h4">
              A partnership between the Trust for Public Land, San Francisco
              Parks Alliance, A. Philip Randolph Institute (APRI), San Francisco
              Recreation &amp; Park Department, and the Bayview-Hunters Point
              community.
            </p>
          </motion.div>

          {/* Prominent EDP CTA */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-foodMaroon text-foodCream border-4 border-foodMaroon p-10 shadow-[12px_12px_0px_0px_#F4631E]" data-id="element-38" data-mp="j4086y55ibc4">
            <h4 className="text-3xl font-extrabold uppercase mb-4 leading-tight" data-id="element-39" data-mp="dijr5rcq1wk">
              Read the Equitable Development Plan
            </h4>
            <p className="text-foodCream/80 font-medium text-lg mb-8" data-id="element-40" data-mp="3rkmotv3xre2c">
              Explore the full landmark plan behind India Basin Waterfront Park
              and The Food Pavilion — the community-first blueprint guiding it
              all.
            </p>
            <a href={EDP_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-foodOrange text-white font-bold text-lg px-8 py-4 border-2 border-foodCream shadow-[4px_4px_0px_0px_#F5EFE0] hover:translate-y-[2px] hover:translate-x-[2px] hover:shadow-[2px_2px_0px_0px_#F5EFE0] transition-all" data-id="element-41" data-mp="3dlmymj0ryr42">
              View the Full EDP
              <ArrowUpRight size={22} data-id="element-42" data-mp="2yy50y4lmqwr5" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}